import axios from 'axios';
import detailData from '../assets/data/details.json';
import detailCategories from '../assets/data/categories.json';
import detailSeekData from '../assets/data/seek.json';
import { PATH } from '../constants';

// ---------------------------------------------------
// Details data
// ---------------------------------------------------

export const getCategoryData = categoryId => detailCategories[categoryId] || [];
export const getDetailData = detailId => detailData[detailId] || {};
export const getDetailSeekData = detailId => detailSeekData[detailId] || [];

// ---------------------------------------------------
// Video image
// ---------------------------------------------------

export const getVideoImageUrl = bonusId =>
  `//decko.ceskatelevize.cz/cms/ct-src/video/b${encodeURIComponent(
    bonusId
  )}/uni.jpg`;

// ---------------------------------------------------
// Form Sending
// ---------------------------------------------------

const FORM_VERSION = '1.0';
let messageText = '';
const messageMeta = {
  v: FORM_VERSION,
  category: '',
  detail: '',
  time: 0,
};

export const updateMessageData = (text, categoryId, detailId, time) => {
  // main text
  messageText = text;
  // meta
  messageMeta.category = categoryId;
  messageMeta.detail = detailId;
  messageMeta.time = time;
};

export const sendMessage = (name, contact) => {
  const formData = new FormData();
  formData.append('action', 'rekonstrukce-okupace');
  formData.append('name', name);
  formData.append('email', '');
  formData.append('phone', contact);
  formData.append('message', messageText);
  formData.append('param1', JSON.stringify(messageMeta));

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: '/rest/Message/sendMessageByAnonymous',
      data: formData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })
      .then(() => {
        /*
        parse response html for errors like:
        <div class="error">
		      <p>Telefonní číslo může mít nejvýše 64 znaků.</p>
	      </div>
        */
        // response; // todo - parse/remove
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

// ---------------------------------------------------
// Item Deco
// ---------------------------------------------------

const decoIdPool = [];
const decoIds = [0, 1, 2];
let lastDecoId = -1;

export const getCiDecoId = () => {
  if (decoIdPool.length === 0) {
    decoIds.forEach(id => {
      if (id !== lastDecoId) {
        decoIdPool.push(id);
      }
    });
  }
  [lastDecoId] = decoIdPool.splice(
    Math.round(Math.random() * (decoIdPool.length - 1)),
    1
  );
  return lastDecoId;
};

// ---------------------------------------------------
// Detail Messages
// ---------------------------------------------------

export const fetchDetailMessages = detailId =>
  new Promise((resolve, reject) => {
    axios
      .get(`${PATH.MESSAGES}detail/msg-${detailId}.json`)
      .then(response => {
        resolve(response.data.msg);
      })
      .catch(() => {
        reject();
      });
  });

// ---------------------------------------------------
// Messages Count Data
// ---------------------------------------------------

export const fetchMsgCount = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${PATH.MESSAGES}msg-count.json`)
      .then(response => {
        resolve(response.data);
      })
      .catch(() => {
        reject();
      });
  });

// ---------------------------------------------------
// Hash
// ---------------------------------------------------

let hashInited = false;
let hash = '';

const fetchHash = () => {
  axios
    .get(
      window.location.href.indexOf('specialy') === -1
        ? '/player'
        : '/specialy/dukla61/player'
    )
    .then(response => {
      hash = response.data.split('vApp')[1].split('"')[1]; // eslint-disable-line prefer-destructuring
      // repeat in given interval
      setTimeout(() => {
        fetchHash();
      }, 1000 * 60 * 30);
    })
    .catch(() => {
      // note - solve error state?
      hash = 'd77a068997682ce5d92b8fc553c1e3b94a705d94';
    });
};

export const initHash = () => {
  if (window.hash) {
    hash = window.hash; // eslint-disable-line prefer-destructuring
  }
  if (!hashInited) {
    hashInited = true;
    fetchHash();
  }
};

export const getHash = () => hash;



// WEBPACK FOOTER //
// ./src/api/index.js